exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{font-family:Heebo,sans-serif;-webkit-text-stroke:2px orange;background:repeating-linear-gradient(0,hsla(0,0%,66%,.24),hsla(0,0%,66%,.24) 9px,hsla(0,0%,95%,.24) 0,hsla(0,0%,95%,.24) 18px),repeating-linear-gradient(90deg,hsla(0,0%,93%,.09),hsla(0,0%,93%,.09) 10px,rgba(73,73,73,.09) 0,rgba(73,73,73,.09) 20px),linear-gradient(90deg,#e84404,#5e1bc1);-webkit-background-clip:text;-webkit-text-fill-color:transparent}.alt-name{padding-bottom:1em}.type-label{color:#fffb00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c28564b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DrugInfo.vue
// module id = 18
// module chunks = 0